export const fip101StatusMessages = {
    productName: 'Fractal Indexer',
    checking: 'Checking system status',
    operational: 'Systems Operational',
    degraded: 'Degraded Service',
    maintenance: 'Maintenance in Progress',
    unavailable: 'Status Unavailable',
    systemOperational: 'System Operational',
    lastUpdated: 'Last Updated:',
    refreshIn: 'Refresh in:',
    retry: 'Retry',
    retainedData: 'Showing the last available data.',
    now: 'now',
    noHeartbeatData: 'No heartbeat data',
} as const
